<template>
	<div>
		<Subpage/>		  
      	 <div class="page-content container">

        <main>          
			<h1 class="page-title">
				Gliwicka Radiostacja</h1>			            
			<div class="breadcrumbs-area">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
						<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
							<router-link itemprop="item" to="/"><span itemprop="name">Strona gł&oacute;wna</span></router-link><span class="separator">/</span>
						</li>
						<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
							<router-link itemprop="item" to="/czy-wiecie-ze"><span itemprop="name">Czy wiecie, że...</span></router-link><span class="separator">/</span>
						</li>
						<li class="active">Gliwicka Radiostacja</li>
					</ol>
				</nav>
			</div>			           			    
			<div class="news-date">9 stycznia 2018</div>
			<div class="news-area">    
			    <div class="thumbnail-area">
			        <img src="@/assets/img/radio.jpg" width="550" height="277" alt="Gliwicka Radiostacja" />
			   	</div>		       		    
			 	<div class="news-content-area">
			        <p>Paryż, od 1889 roku ma swoją &bdquo;Żelazną Damę&rdquo; &ndash; wieżę Eiffla. Śląsk też ma swoją wieżę Eiffla &ndash; gliwicką Radiostację, kt&oacute;ra g&oacute;ruje nad miastem od&nbsp; roku 1935. I chociaż była to kolejna stacja nadajnika w&nbsp;mieście (wcześniejsza mieściła się na dzisiejszej ulicy Radiowej i składała się z dw&oacute;ch żelaznych wież), to ta stała się jego symbolem. Dlaczego? Odpowiedź jest prosta &ndash; niejedna puszka miodopłynnego, złocistego trunku przelała się w przegranym zakładzie o rację jak została wzniesiona ta ażurowa konstrukcja. Ot&oacute;ż szaroczarne elementy do złudzenia przypominają żelazo, jednak prawda jest o wiele bardziej ekologiczna. Konstrukcję kratownicy tworzą DREWNIANE belki, scalone ze sobą bez użycia gwoździ. Ta 111 metrowa wieża to najwyższa na świecie drewniana wieża nadawcza, wpisana do księgi rekord&oacute;w Guinessa. Dziesięć lat temu była najwyższą drewnianą budowlą na&nbsp;świecie, p&oacute;ki nie &bdquo;przerosła&rdquo; jej o blisko 43 metry pagoda świątyni Tianning w Changzhou koło Szanghaju. W Europie gliwicka konstrukcja pozostaje wciąż numerem jeden!</p>		        		        
			        <br>
			        <p>
			        	<router-link to="/czy-wiecie-ze" class="arrow-link">Zobacz pozostałe</router-link>
			        </p>      
			    	<div class="clearfix"></div>       
			    </div>
			</div>
        </main>
    </div>
	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'Gliwicka',
  components: {
    Subpage
  }
}
</script>